import _async_to_generator from "@swc/helpers/src/_async_to_generator.mjs";
import _sliced_to_array from "@swc/helpers/src/_sliced_to_array.mjs";
import _ts_generator from "@swc/helpers/src/_ts_generator.mjs";
import { Check, Guard } from "@silvertours/lib-core-types";
import { makeAttributePageContentLoader } from "./loadAttributePage";
import { makeAttributePagesLoader } from "./loadAttributePages";
export var makePageContentService = function(logger, contentRepo, linksRepo) {
    var loadAttributePageContent = makeAttributePageContentLoader(logger, contentRepo);
    var loadAttributePages = makeAttributePagesLoader(loadAttributePageContent);
    return {
        getPageAncestorReferences: function getPageAncestorReferences(slug, primaryAttribute) {
            return _async_to_generator(function() {
                var ref, _attributes, city, cityDistrict, country, state, _pages, pageForAttribute, pageForCityDistrict, pageForCity, pageForState, pageForCountry;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (!Check.isDefined(primaryAttribute)) {
                                logger.warn("A page was loaded without any parent attribute", {
                                    slug: slug
                                });
                                return [
                                    2,
                                    []
                                ];
                            }
                            return [
                                4,
                                loadAttributePages(slug, primaryAttribute)
                            ];
                        case 1:
                            ref = _state.sent(), _attributes = ref.attributes, city = _attributes.city, cityDistrict = _attributes.cityDistrict, country = _attributes.country, state = _attributes.state, _pages = _sliced_to_array(ref.pages, 5), pageForAttribute = _pages[0], pageForCityDistrict = _pages[1], pageForCity = _pages[2], pageForState = _pages[3], pageForCountry = _pages[4];
                            /**
       * Return the pages for those entities which are available
       */ return [
                                2,
                                [
                                    [
                                        country,
                                        pageForCountry
                                    ],
                                    [
                                        state,
                                        pageForState
                                    ],
                                    [
                                        city,
                                        pageForCity
                                    ],
                                    [
                                        cityDistrict,
                                        pageForCityDistrict
                                    ],
                                    [
                                        primaryAttribute,
                                        pageForAttribute
                                    ]
                                ].filter(function(param) {
                                    var _param = _sliced_to_array(param, 1), entity = _param[0];
                                    return Check.isTruthy(entity);
                                })
                            ];
                    }
                });
            })();
        },
        getPageContentForSlug: function getPageContentForSlug(slug) {
            return contentRepo.loadPageContentForSlug(slug);
        },
        getPageLinks: function getPageLinks(param) {
            var attributeSet = param.attributeSet, product = param.product, slug = param.slug;
            Guard.isDefined(linksRepo, {
                errorMessage: "The page links repository is not defined",
                errorData: {
                    slug: slug,
                    product: product
                }
            });
            return linksRepo.loadPageLinks(slug, product.id, attributeSet);
        }
    };
};
